import React, { FC } from 'react';
import { ReactComponent as BackArrow } from '@assets/back-arrow.svg';
import useDeviceType from '@hooks/useDeviceType';

import st from './BackButton.module.css';

type BackButtonProps = {
  text: string;
  onClick: () => void;
};

const BackButton: FC<BackButtonProps> = ({ text, onClick }) => {
  const { phone, tablet } = useDeviceType();

  return (
    (phone || tablet) && (
      <button type="button" className={st.button} onClick={onClick}>
        <div className={st.icon}>
          <BackArrow />
        </div>
        <span className={st.text}>{text}</span>
      </button>
    )
  );
};

export default BackButton;
